export const letterTemplates = {
  spanish: {
    dateLabel: 'Fecha',
    greeting: 'Estimado/a',
    content: `Mi nombre es {{agent_name}}. Soy Voluntario(a) de PROSPERITY LEADERS Enterprise Corp.; una organización autosostenible con la misión de expandir educación financiera para ayudar a las comunidades a aprender, crecer, y prosperar. Me comunico hacia usted para solicitar su colaboración en expandir educación financiera a través de talleres y seminarios para la comunidad.

Para ser específico, solicito la colaboración entre la oficina de {{office}} y Prosperity Leaders para descubrir oportunidades de desarrollo de talleres, seminarios, y conferencias para incrementar la educación financiera en {{city}}.

Como alternativa, o a la misma vez, me gustaría recibir su asistencia para CONTACTAR a los MIEMBROS DE LA COMUNIDAD para asistir en persona o través de talleres virtuales a estos futuros eventos.

Prosperity Leaders no cobra honorarios, ni tampoco vende productos o servicios financieros propios ni de ningún banco o institución financiera. Somos una organización autosostenida que recibe el apoyo de profesionales financieros, asesores, y líderes comunitarios a cambio de entrenamiento, desarrollo profesional y exposición a comunidades que pueden avanzar su credibilidad y experiencia.

De esta manera, Prosperity Leaders combina el conocimiento y experiencia de profesionales en finanzas con la necesidad de educación financiera de nuestras comunidades.`,
    closing: 'Cordialmente espero escuchar de usted pronto:',
    recognition: `Nuestra organización ha crecido y recibido el reconocimiento y apoyo de:

• Bloomberg Businessweek – "Kids Jumping on the Investing Bandwagon" (OCT/2021)
• Essex County College and ACBSP – "Global Business Accreditation"
• Vogue Latin America Magazine – AUG/2020
• The Consulate of Ecuador in Queens – 24-15 Queens Plaza N, Queens, NY 11101
• CREA NY (Center for Recreative Education for Adults)
• PS 19 – Marino Jeantet – 98-02 Roosevelt Ave, Queens, NY 11368
• P.S. 150 Queens – 40-01 43rd Ave, Sunnyside, NY 11104
• Counseling Service of EDNY | New York Naval Cadet Corps
• Lulac NY – League of United Latin American Citizens
• Tu Apoyo Latino – Conectando a la comunidad latina con recursos para avanzar el éxito familiar y empresarial

Empresas y aliados que apoyan nuestros programas:
Ethos • Ameritas • Fidelity & Guaranty • Corebridge • Mutual of Omaha • American National • American Equity • Allianz • Foresters Financial • National Western • Prudential • SBLI • Lincoln Financial Group y más...`,
    signatureOrder: 'representative-first'
  },
  
  english: {
    dateLabel: 'Date',
    greeting: 'Dear',
    content: `My name is {{agent_name}}, a Volunteer with PROSPERITY LEADERS Enterprise Corp., a self-sustaining organization with the mission to expand financial education and help communities learn, grow, and prosper. I am reaching out to request your collaboration in expanding financial education through workshops and community seminars.

Specifically, I am requesting collaboration between {{office}} and Prosperity Leaders to explore opportunities to develop workshops, seminars, and conferences that will increase financial education in {{city}}.

Alternatively, or simultaneously, I would love your assistance in CONTACTING COMMUNITY MEMBERS to participate either in person or virtually in these future events.

Prosperity Leaders does not charge fees, nor do we sell our own or any bank's financial products or services. We are a self-sustaining organization supported by financial professionals, advisors, and community leaders in exchange for training, professional development, and exposure to communities seeking to advance their financial literacy and credibility.

In this way, Prosperity Leaders combines the knowledge and experience of financial professionals with the need for financial education in our communities.`,
    closing: 'I look forward to hearing from you soon.',
    recognition: `Our organization has grown and received recognition and support from:

• Bloomberg Businessweek – "Kids Jumping on the Investing Bandwagon" (OCT/2021)
• Essex County College and ACBSP – "Global Business Accreditation"
• Vogue Latin America Magazine – AUG/2020
• The Consulate of Ecuador in Queens – 24-15 Queens Plaza N, Queens, NY 11101
• CREA NY (Center for Recreative Education for Adults)
• PS 19 – Marino Jeantet – 98-02 Roosevelt Ave, Queens, NY 11368
• P.S. 150 Queens – 40-01 43rd Ave, Sunnyside, NY 11104
• Counseling Service of EDNY | New York Naval Cadet Corps
• Lulac NY – League of United Latin American Citizens
• Tu Apoyo Latino – Connecting the Latino community with resources to advance family and business success

Companies and partners supporting our programs:
Ethos • Ameritas • Fidelity & Guaranty • Corebridge • Mutual of Omaha • American National • American Equity • Allianz • Foresters Financial • National Western • Prudential • SBLI • Lincoln Financial Group and more...`,
    signatureOrder: 'representative-first'
  }
};